import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { Router } from '@angular/router';
import { EpbtFieldAgentService } from '../../services/epbt-field-agent.service';
import { FieldAgentClient, GetCustomerAddressHeadersRequest, Address } from 'ep-bt-field-agent-proxy';
import { PagingParameters, SortParameters, SortParametersDirection, SearchParameters } from 'ep-bt-field-agent-proxy';

@Component({
  selector: 'epbt-fa-competitor-price-address-list',
  templateUrl: './epbt-fa-competitor-price-address-list.component.html',
  styleUrls: ['./epbt-fa-competitor-price-address-list.component.scss']
})
export class EpbtFaCompetitorPriceAddressListComponent implements OnInit {

  searchParams: any;
  webTrackUser: any;
  competitorAddressRequest: GetCustomerAddressHeadersRequest;
  paging: PagingParameters;
  sort: SortParameters;
  public pageSize: number = 10;
  competitorAddress: any;
  @Input() customerId: number;
  @Input() customerAddress: Address[] = [];

  private _selectedAddressId: number;

  @Input('selectedAddressId') set selectedAddressId(value: number) {
    this._selectedAddressId = value;
    if (this._selectedAddressId) {
      var result = this.customerAddress.filter(x => x.addressId == this._selectedAddressId);
      this.selectedAddressCodeChange.emit(result ? result[0] : null);
    }
  }

  get selectedAddressId(): number {
    return this._selectedAddressId;
  }

  @Output() selectedAddressCodeChange = new EventEmitter<any>();


  constructor(private fieldAgentService: EpbtFieldAgentService, private client: FieldAgentClient) { }


  ngOnInit() {

    if (this.customerId) {
      // this.customerId = this.epbtFaCompetitorService.competitorPricing.customer.customerId;
      this.fieldAgentService.getWebTrackUser((webTrackUser: any) => {
        this.webTrackUser = webTrackUser;
        // this.addressCodeDropDown();
      });
    }
  }



  //api call start

  addressCodeDropDown() {
    this.customerAddress = [];
    this.competitorAddressRequest = new GetCustomerAddressHeadersRequest();
    // In BisTrack Cloud, we do not limit to WebTrack-only customers.
    this.competitorAddressRequest.currentUser = this.webTrackUser;
    this.competitorAddressRequest.currentUser.customer.customerId = this.customerId;

    this.paging = new PagingParameters();
    this.paging.index = 0;
    this.paging.count = this.pageSize;
    this.competitorAddressRequest.paging = this.paging;

    this.sort = new SortParameters();
    this.sort.sortColumn = "AddressCode";
    this.sort.direction = SortParametersDirection.Ascending;
    this.competitorAddressRequest.sorting = this.sort;

    let customerAddressSearchParameter = new SearchParameters();
    customerAddressSearchParameter.paging = this.paging;
    customerAddressSearchParameter.sorting = this.sort;
    customerAddressSearchParameter.customerId = this.customerId;

    this.competitorAddressRequest.searchParameters = customerAddressSearchParameter;
    this.competitorAddressRequest.searchParameters.searchText = "";



    this.client.getCustomerAddressHeaders(this.competitorAddressRequest).subscribe(res => {

      if (res != null) {
        // this.customerAddress = res.lines;
        res.lines.forEach(item => {
          this.customerAddress.push(item.address);
        });
      //  this.selectedAddressId = 2933;
        // res.lines.forEach(data => {
        //   let cardModel: any =
        //   {
        //     id: data.address.addressId,
        //     addressCode: data.address.addressCode
        //   }
        //   this.customerAddress.push(cardModel);
        // })

        // this.epbtFaCompetitorService.competitorPricing.competitorAddress = this.customerAddress;
        // this.epbtFaCompetitorService.competitorPricing.SelectedAddress = this.customerAddress[0];
        // this.epbtFaCompetitorService.competitorPricing.SelectedAddressIndex = this.customerAddress[0].addressId;
        // this.selectedAddressCodeChange.emit(this.customerAddress && this.customerAddress.length > 0 ? this.customerAddress[0] : null);
      }
      //console.log(this.customerAddress, "competitors addredd data")
    });

  }

  onSelectionAddresscode(selectedValue: any) {
    if (selectedValue) {
      this.selectedAddressId = selectedValue.addressId;
      var result = this.customerAddress.filter(x => x.addressId == this.selectedAddressId);
      this.selectedAddressCodeChange.emit(result ? result[0] : null);
      // this.epbtFaCompetitorService.competitorPricing.SelectedAddress = this.customerAddress.find(item => item.addressId == this.epbtFaCompetitorService.selectCompetitorAddress);
    }
  }

}
